<template>
  <Card
    title="Database"
    :error="adapterError"
    errorTitle="Failed to Connect"
    class="fill-height"
  >
    <template #header-suffix>
      <ConnectionIndicator :connected="adapterConnected" />
    </template>
    <DatabaseForm
      v-model="database"
      :enabled="!adapterLoading && !adapterConnected"
      @submit="connect"
    />
    <template v-slot:footer>
      <Button
        v-if="!adapterConnected"
        :loading="adapterLoading"
        @click="connect"
        variant="success"
      >
        Connect
      </Button>
      <Button v-if="adapterConnected" @click="change">
        Change
      </Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import store from '@/plugins/vuex';
import Button from '@/components/Button.vue';
import Card from '@/components/Card.vue';
import DatabaseForm from '@/components/adapters/DatabaseForm.vue';
import ConnectionIndicator from '@/components/ConnectionIndicator.vue';

export default defineComponent({
  name: 'Source',
  components: {
    Button,
    Card,
    DatabaseForm,
    ConnectionIndicator,
  },
  // data() { },
  computed: {
    ...mapState({
      adapterConnected: (state: any) => state.source.adapterConnected,
      adapterLoading: (state: any) => state.source.adapterLoading,
      adapterError: (state: any) => state.source.adapterError,
    }),
    database: {
      get() {
        return store.getters.source.connectRequest;
      },
      set(val) {
        store.dispatch.source.updateAdapter(val);
      },
    },
  },
  methods: {
    connect() {
      store.dispatch.source.connectAdapter(null);
    },
    change() {
      store.dispatch.source.updateAdapter(this.database);
    },
  },
});
</script>
